import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../graphql/types.generated';
export type GetNotificationsQueryVariables = GraphQLTypes.Exact<{
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type GetNotificationsQueryResult = { __typename?: 'Query' } & {
  notifications?: GraphQLTypes.Maybe<
    { __typename?: 'Notifications' } & {
      notificationsPerTarget: { __typename?: 'TargetNotificationsConnection' } & Pick<
        GraphQLTypes.TargetNotificationsConnection,
        'totalCount'
      > & {
          nodes?: GraphQLTypes.Maybe<
            Array<
              GraphQLTypes.Maybe<
                { __typename?: 'TargetNotifications' } & Pick<
                  GraphQLTypes.TargetNotifications,
                  'targetId' | 'targetType' | 'unreadNotificationIds'
                > & {
                    lastNotificationItem: { __typename: 'Activity' } & Pick<
                      GraphQLTypes.Activity,
                      'createdAt' | 'id' | 'itemId' | 'itemType'
                    > & {
                        legacyUser?: GraphQLTypes.Maybe<
                          { __typename?: 'NetworksContact' } & Pick<GraphQLTypes.NetworksContact, 'firstName' | 'lastName'>
                        >;
                        user?: GraphQLTypes.Maybe<
                          { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                        >;
                      };
                  }
              >
            >
          >;
          pageInfo: { __typename: 'PageInfo' } & Pick<
            GraphQLTypes.PageInfo,
            'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
          >;
        };
    }
  >;
};

export const GetNotificationsDocument = gql`
  query getNotifications($after: String, $before: String) {
    notifications {
      notificationsPerTarget(after: $after, before: $before) {
        nodes {
          lastNotificationItem {
            ... on Activity {
              __typename
              createdAt
              id
              itemId
              itemType
              legacyUser {
                firstName
                lastName
              }
              user {
                firstName
                lastName
              }
            }
          }
          targetId
          targetType
          unreadNotificationIds
        }
        pageInfo {
          ...PageInfo
        }
        totalCount
      }
    }
  }
  ${PageInfoFragmentDoc}
`;
